import { ReactComponent as MenuCloseIcon } from '../../../assets/icons/menu-close-icon.svg';
import { ReactComponent as MenuOpenIcon } from '../../../assets/icons/menu-open-icon.svg';
import { ReactComponent as ChromeExtensionIcon } from '../../../assets/icons/chrome-extension-icon.svg';
import { ReactComponent as MobileIcon } from '../../../assets/icons/mobile-icon.svg';
import { ReactComponent as SettingsIcon } from '../../../assets/sideNavigation/settings_outlined.svg';

type SvgComponent = React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
type MenuItem = {
  icon: SvgComponent;
  text: string;
  key: string;
  onClick?: () => void;
};

export const SIDEBAR_MENU = {
  open: MenuOpenIcon,
  close: MenuCloseIcon,
  chromeExtension: ChromeExtensionIcon,
  mobile: MobileIcon,
  settings: SettingsIcon,
};

export const MENU_ITEMS: MenuItem[] = [
  {
    icon: SIDEBAR_MENU.mobile,
    text: 'Mobile App',
    key: 'mobile',
  },
  {
    icon: SIDEBAR_MENU.chromeExtension,
    text: 'Chrome Extension',
    key: 'chromeExtension',
    onClick: () =>
      window.open(
        'https://chromewebstore.google.com/detail/lifestack-extension/mbpcaihbaecjnndomdpkigmmhdnfccjb',
        '_blank'
      ),
  },
  {
    icon: SIDEBAR_MENU.settings,
    text: 'Settings',
    key: 'settings',
  },
];
